/**
 * Kde a jak dlouho žije přihlášení.
 *
 * Bloom si přihlášení nepamatuje napříč návštěvami. Token leží v sessionStorage,
 * ne v localStorage – rozdíl je zásadní:
 *
 *   localStorage    přežije zavření prohlížeče. Kdo se k počítači dostane
 *                   později, je přihlášený jako ten člověk.
 *   sessionStorage  žije jen v téhle záložce a při jejím zavření zmizí.
 *                   Obnovení stránky (F5) i pohyb po aplikaci přežije.
 *
 * U aplikace pro trans komunitu je „zůstat přihlášená" nebezpečná pohodlnost:
 * sdílený počítač, cizí telefon, někdo, kdo se člověku podívá do prohlížeče.
 * Proto se odhlašuje i po nečinnosti.
 */

const KLIC = 'token';

// Po jak dlouhé nečinnosti se odhlásit. Deset minut je kompromis mezi
// bezpečím a tím, aby to neotravovalo uprostřed psaní zprávy.
export const NECINNOST_MS = 10 * 60 * 1000;

// Krátce před odhlášením se ukáže varování, ať to člověka nepřekvapí.
export const VAROVANI_PRED_MS = 60 * 1000;

export const dejToken = () => {
  try {
    return sessionStorage.getItem(KLIC);
  } catch {
    // Prohlížeč může úložiště zakázat (soukromé okno, přísné nastavení).
    // Aplikace pak funguje jen do obnovení stránky – což je bezpečnější
    // selhání než tiše přejít na trvalé úložiště.
    return null;
  }
};

export const ulozToken = (token) => {
  try {
    sessionStorage.setItem(KLIC, token);
  } catch { /* viz výše */ }
};

export const smazToken = () => {
  try {
    sessionStorage.removeItem(KLIC);
  } catch { /* viz výše */ }
  // Úklid po starších verzích Bloomu, které token držely natrvalo.
  try {
    localStorage.removeItem(KLIC);
  } catch { /* nic */ }
};

/**
 * Hlídá nečinnost. Vrací funkci, kterou se hlídání zruší.
 *
 * `onVarovat` se zavolá minutu před odhlášením, `onOdhlasit` při vypršení.
 */
export function hlidejNecinnost(onVarovat, onOdhlasit) {
  let casovacVarovani;
  let casovacOdhlaseni;

  const naplanuj = () => {
    clearTimeout(casovacVarovani);
    clearTimeout(casovacOdhlaseni);
    casovacVarovani = setTimeout(onVarovat, NECINNOST_MS - VAROVANI_PRED_MS);
    casovacOdhlaseni = setTimeout(onOdhlasit, NECINNOST_MS);
  };

  // Cokoli, co znamená, že u toho člověk je.
  const udalosti = ['mousedown', 'keydown', 'touchstart', 'scroll', 'visibilitychange'];
  const reset = () => {
    if (document.visibilityState === 'hidden') return;   // schovaná záložka se nepočítá
    naplanuj();
  };

  udalosti.forEach((u) => window.addEventListener(u, reset, { passive: true }));
  naplanuj();

  return () => {
    clearTimeout(casovacVarovani);
    clearTimeout(casovacOdhlaseni);
    udalosti.forEach((u) => window.removeEventListener(u, reset));
  };
}
